import * as React from 'react';

const EmptyUnReadMsg = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={90} height={90} fill="none">
    <path
      fill="#F9F9F9"
      d="M87.928 17.316a27.858 27.858 0 0 1 2.07 10.801v33.75A27.857 27.857 0 0 1 61.877 89.99H5.637A5.315 5.315 0 0 1 .01 84.363V28.124A27.858 27.858 0 0 1 28.133.001h33.743a27.858 27.858 0 0 1 26.052 17.315Z"
    />
    <path
      fill="#2961FA"
      d="M44.284 49.97H18.289c-1.08 0-2.116-.42-2.88-1.166a3.934 3.934 0 0 1-1.193-2.814v-8.51h30.068c1.08 0 2.116.419 2.88 1.165a3.934 3.934 0 0 1 1.193 2.814v4.531c0 1.056-.429 2.068-1.193 2.814a4.123 4.123 0 0 1-2.88 1.166Z"
      opacity={0.14}
    />
    <path
      fill="#2961FA"
      d="M45.155 15.829h18.893c1.138 0 2.23.468 3.036 1.3a4.52 4.52 0 0 1 1.257 3.14v8.883H45.155a4.223 4.223 0 0 1-3.036-1.3 4.52 4.52 0 0 1-1.258-3.141V20.27a4.52 4.52 0 0 1 1.258-3.14 4.223 4.223 0 0 1 3.036-1.301ZM45.155 58.297h18.893c1.138 0 2.23.468 3.036 1.301a4.52 4.52 0 0 1 1.257 3.14v8.883H45.155a4.223 4.223 0 0 1-3.036-1.3 4.52 4.52 0 0 1-1.258-3.141v-4.441a4.52 4.52 0 0 1 1.258-3.14 4.223 4.223 0 0 1 3.036-1.302Z"
    />
    <rect
      width={1.602}
      height={23.566}
      x={68.592}
      y={30.818}
      fill="silver"
      rx={0.801}
      transform="rotate(90 68.592 30.818)"
    />
    <rect
      width={1.602}
      height={23.566}
      x={37.533}
      y={51.704}
      fill="silver"
      rx={0.801}
      transform="rotate(90 37.533 51.704)"
    />
    <rect
      width={1.602}
      height={23.566}
      x={68.592}
      y={73.287}
      fill="silver"
      rx={0.801}
      transform="rotate(90 68.592 73.287)"
    />
    <rect
      width={1.665}
      height={18.32}
      x={65.01}
      y={19.992}
      fill="#CCC"
      rx={0.833}
      transform="rotate(90 65.01 19.992)"
    />
    <rect
      width={1.665}
      height={11.658}
      x={65.01}
      y={23.323}
      fill="#CCC"
      rx={0.833}
      transform="rotate(90 65.01 23.323)"
    />
    <rect
      width={1.602}
      height={23.566}
      x={41.109}
      y={41.643}
      fill="silver"
      rx={0.801}
      transform="rotate(90 41.11 41.643)"
    />
    <rect
      width={1.665}
      height={14.989}
      x={32.535}
      y={44.974}
      fill="silver"
      rx={0.833}
      transform="rotate(90 32.535 44.974)"
    />
    <rect
      width={1.665}
      height={18.32}
      x={65.01}
      y={62.461}
      fill="#CCC"
      rx={0.833}
      transform="rotate(90 65.01 62.461)"
    />
    <rect
      width={1.665}
      height={11.658}
      x={65.01}
      y={65.792}
      fill="#CCC"
      rx={0.833}
      transform="rotate(90 65.01 65.792)"
    />
  </svg>
);
export default EmptyUnReadMsg;
